<template>
    <v-container class="py-10">
        <h2>General Survey</h2>
        <v-row>
            <v-col cols="6">
                <v-radio-group v-model="formData.physical_examination.general_survey.gen_survey_id" row>
          <v-radio label="Awake and Alert" value="1" @change="generalSurveyTick(1)"></v-radio>
          <v-radio label="Altered Sensorium" value="2" @change="generalSurveyTick(2)"></v-radio>
                </v-radio-group>
                <v-text-field
                        v-if="isGeneralSurveyRemark"
                        outlined
                        v-model="formData.physical_examination.general_survey.gen_survey_remark"
                        :rules="[v => !!v || 'Altered Sensorium remarks is required']"
                        label="Altered Sensorium Remarks"
                        required
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "GeneralSurvey",

        props: {
            formData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                isGeneralSurveyRemark: false,
                generalSurveyConfig: 2,
                generalSurvey: [],
            }
        },

        methods: {
            generalSurveyTick(id) {
                this.isGeneralSurveyRemark = this.generalSurveyConfig == id;
            },

            setGeneralSurveyRemark() {
                this.isGeneralSurveyRemark = this.formData.physical_examination.general_survey.gen_survey_id == this.generalSurveyConfig;
            },

            getGeneralSurveyLib() {
                this.axios.get('general-survey-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.generalSurvey = response.data;
                }).catch((error) => {
                    // handle error
                    console.error(error);
                }).finally(() => {
                    // always executed
                });
            },

            getGeneralSurveyConfig() {
                this.axios.get('config-general-survey', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.generalSurveyConfig = response.data;
                }).catch((error) => {
                    // handle error
                    console.error(error);
                }).finally(() => {
                    // always executed
                });
            },


        },

        mounted() {
            this.getGeneralSurveyLib();
            this.getGeneralSurveyConfig();
            this.setGeneralSurveyRemark();
        }
    }
</script>

<style scoped>

</style>